import * as tslib_1 from "tslib";
import { isPropsValid, mergeEventStores } from '@fullcalendar/core';
import ResourceSplitter from './common/ResourceSplitter';
export function isPropsValidWithResources(props, calendar) {
    var splitter = new ResourceSplitter();
    var sets = splitter.splitProps(tslib_1.__assign({}, props, { resourceStore: calendar.state.resourceStore }));
    for (var resourceId in sets) {
        var props_1 = sets[resourceId];
        // merge in event data from the non-resource segment
        if (resourceId && sets['']) { // current segment is not the non-resource one, and there IS a non-resource one
            props_1 = tslib_1.__assign({}, props_1, { eventStore: mergeEventStores(sets[''].eventStore, props_1.eventStore), eventUiBases: tslib_1.__assign({}, sets[''].eventUiBases, props_1.eventUiBases) });
        }
        if (!isPropsValid(props_1, calendar, { resourceId: resourceId }, filterConfig.bind(null, resourceId))) {
            return false;
        }
    }
    return true;
}
function filterConfig(resourceId, config) {
    return tslib_1.__assign({}, config, { constraints: filterConstraints(resourceId, config.constraints) });
}
function filterConstraints(resourceId, constraints) {
    return constraints.map(function (constraint) {
        var defs = constraint.defs;
        if (defs) { // we are dealing with an EventStore
            // if any of the events define constraints to resources that are NOT this resource,
            // then this resource is unconditionally prohibited, which is what a `false` value does.
            for (var defId in defs) {
                var resourceIds = defs[defId].resourceIds;
                if (resourceIds.length && resourceIds.indexOf(resourceId) === -1) { // TODO: use a hash?!!! (for other reasons too)
                    return false;
                }
            }
        }
        return constraint;
    });
}
